<template>
  <a-modal
    v-model:visible="visible"
    title="预览弹框"
    class="preview-modal"
    :width="terminal == 'pc' ? '1200px' : '400px'"
    :style="{ height: terminal == 'pc' ? '90%' : '600px' }"
    :footer="null"
  >
    <!-- <a-radio-group v-model:value="terminal" button-style="solid">
      <a-radio-button value="pc">PC</a-radio-button>
      <a-radio-button value="m">M</a-radio-button>
    </a-radio-group> -->
    <div class="input-container">
      <a-input placeholder="要测试的url" v-model:value="testUrl"></a-input>
      <a-button type="primary" :disabled="!testUrl" @click="createIframe">
        执行预览
      </a-button>
    </div>
    <div id="iframeContainer"></div>
  </a-modal>
</template>
<script setup>
import { defineProps, ref, defineEmits, watch } from 'vue'
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  },
  sourceObj: {
    cssContent: '',
    scriptContent: ''
  }
})
const emit = defineEmits(['update:show'])
const visible = ref(false)
const testUrl = ref('')
const terminal = ref('pc')
const createIframe = () => {
  const iframeContainer = document.getElementById('iframeContainer')
  iframeContainer.innerHTML = ''
  iframeContainer.insertAdjacentHTML(
    'beforeend',
    `<iframe id="iframeId" src="${testUrl.value}" style="width:100%;height:100%"></iframe>`
  )
  try {
    window.addEventListener(
      'message',
      function() {
        document
          .getElementById('iframeId')
          .contentWindow.postMessage(JSON.stringify(props.sourceObj), '*')
      },
      false
    )
  } catch (error) {
    console.log(error)
  }
}
watch(
  () => terminal,
  () => {
    createIframe()
  }
)
watch(
  () => props.show,
  newVal => {
    visible.value = newVal
  }
)
watch(
  () => visible.value,
  newVal => {
    emit('update:show', newVal)
  }
)
</script>
<style>
.preview-modal .ant-modal-content {
  height: 100%;
}
.preview-modal .ant-modal-body {
  height: calc(100% - 60px);
  overflow: hidden;
}
.input-container {
  display: flex;
  margin-top: 10px;
  margin-bottom: 20px;
}
.input-container .ant-btn {
  flex: 1;
}
#iframeContainer {
  height: 100%;
  overflow: auto;
  border: 2px dashed #999;
  padding: 10px;
}
</style>
